var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Checkbox, FormControlLabel, styled } from "@mui/material";
var StyledFormControlLabel = styled(FormControlLabel)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiFormControlLabel-label": {
            fontSize: "0.875rem",
            color: theme.palette.text.primary,
        },
    });
});
export var CustomCheckBox = function (_a) {
    var checkboxProps = _a.checkboxProps, labelProps = __rest(_a, ["checkboxProps"]);
    return (_jsx(StyledFormControlLabel, __assign({ control: _jsx(Checkbox, __assign({}, checkboxProps)) }, labelProps)));
};
